import { useEffect } from 'react'

export const PageFooter = () => {
  useEffect(() => {
    const footerElement = document.querySelector('footer')
    if (footerElement?.classList.contains('f-hidden')) {
      footerElement.classList.toggle('f-hidden')
    }
  }, [])

  return null
}
